// extracted by mini-css-extract-plugin
export default {"footer":"d6-z"};